// extracted by mini-css-extract-plugin
export default {"loading":"addressForm_loading__l2k94","h5Wrap":"addressForm_h5Wrap__r7wit"};